import { render, staticRenderFns } from "./LoadMoreIcon.vue?vue&type=template&id=904b9e90&"
import script from "./LoadMoreIcon.vue?vue&type=script&lang=js&"
export * from "./LoadMoreIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports